import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";

export class NewsWidgetArticleDisplayEvent extends BaseAnalyticsEvent {
  countryId: Number;
  langId: Number;
  sportTypeId: Number;
  sourceId: Number;
  articleId: Number;

  constructor(params) {
    super('display', 'article', 'articles-component');

    this.countryId = params.countryId;
    this.langId = params.langId;
    this.sportTypeId = params.sportTypeId;
    this.sourceId = params.sourceId
    this.articleId = params.articleId
  }

  get properties() {
    const properties = super.properties;

    properties.countryId = this.countryId;
    properties.langId = this.langId;
    properties.sportTypeId = this.sportTypeId;
    properties.sourceId = this.sourceId;
    properties.articleId = this.articleId;

    return properties;
  }
}